module.exports = __webpack_public_path__ + "img/ezgif.com-apng-maker-6.0d59d871.png";